var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score-stars",attrs:{"id":"score-stars"}},_vm._l((!isNaN(_vm.score) && _vm.pure ? _vm.score : 5),function(item,index){return _c('span',{key:index,class:_vm.score >= item ? 'active' : ''},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }